// The loose React shim (`export =`) forbids named imports, so hooks are re-exported here with light typings.
import React from 'react';
const R = React as any;
export const useState: <T>(init: T | (() => T)) => [T, (v: T | ((prev: T) => T)) => void] = R.useState;
export const useEffect: (fn: () => void | (() => void), deps?: unknown[]) => void = R.useEffect;
export const useRef: <T>(init: T) => { current: T } = R.useRef;
export const useMemo: <T>(fn: () => T, deps: unknown[]) => T = R.useMemo;
export const useCallback: <T>(fn: T, deps: unknown[]) => T = R.useCallback;
export const useContext: <T>(ctx: unknown) => T = R.useContext;
export const createContext: <T>(def: T) => { Provider: any } = R.createContext;
export const useId: () => string = R.useId;
